module.exports = __webpack_public_path__ + "img/down.91e5938e.svg";